/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable no-case-declarations */
/* eslint-disable complexity */
/* eslint-disable max-lines */
import { Injectable } from '@angular/core';
import {
  ILoginUserNamePasswordInput,
  LoginAuthWithCredentials,
  LoginOAuth,
  LoginOAuthParams,
  OauthAEMConfig,
  PkceCode,
  RememberMeDetails,
  SwapAuthForAccessTokens,
  SwapAuthForAccessTokensParams
} from '../../models';
import { AuthorizationService } from '../authorization-service/authorization-service';
import { RedirectfulService } from '../redirectful-service/redirectful.service';
import { PostWithContinueService } from '../remember-me-adapter-service/post-with-continue/post-with-continue-service';
import { PostWithCredService } from '../remember-me-adapter-service/post-with-cred/post-with-cred-service';
import { PostWithFingerPrintService } from '../remember-me-adapter-service/post-with-fingerprint/post-with-fingerprint-service';
import { PostWithRememberUserService } from '../remember-me-adapter-service/post-with-remember-user/post-with-remember-user-service';
import { SwapAccessTokenService } from '../swap-access-token-service/swap-access-token-service';
import { UtilService } from '../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class RememberMeWrapperService {
  loginOAuth: LoginOAuth = {} as LoginOAuth;
  loginAuthWithCredentials: LoginAuthWithCredentials =
    {} as LoginAuthWithCredentials;

  swapAuthForAccessTokens: SwapAuthForAccessTokens =
    {} as SwapAuthForAccessTokens;

  rememberMeDetails: RememberMeDetails | undefined;
  storedFlowId: string | undefined;
  errorFromTokenCall = false;
  promptLoginFlow = false;
  forcePromptLoginFlow = false;

  constructor(
    private authService: AuthorizationService,
    private postWithFingerprintService: PostWithFingerPrintService,
    private postWithCredService: PostWithCredService,
    private postWithRememberUserService: PostWithRememberUserService,
    private postWithContinue: PostWithContinueService,
    private swapAuthForAccessTokenService: SwapAccessTokenService,
    private redirectfulService: RedirectfulService,
    private utils: UtilService
  ) {}

  async initiatePingFlow(
    authConfig: OauthAEMConfig,
    pkceCodeValue: PkceCode,
    requestInput?: ILoginUserNamePasswordInput,
    redirectfulFlowId?: string,
    promptValue?: boolean
  ) {
    this.removeLoggedInSessionStorage(authConfig);

    const loginOAuthParams: LoginOAuthParams = {
      oauthConfig: authConfig,
      pkceCode: pkceCodeValue,
      prompt: promptValue
    };

    if (redirectfulFlowId && !requestInput) {
      return (this.loginAuthWithCredentials =
        await this.redirectfulService.loginOAuthRedirectful(
          authConfig,
          redirectfulFlowId
        ));
    }

    if (!redirectfulFlowId) {
      if (!requestInput) {
        this.loginOAuth = await this.authService.loginOAuth(loginOAuthParams);
        this.storedFlowId = this.loginOAuth?.id;

        if (
          this.loginOAuth &&
          this.loginOAuth?.status === authConfig.USERNAME_PASSWORD_REQUIRED
        ) {
          if (loginOAuthParams.prompt) {
            this.promptLoginFlow = true;
          }
          const returnObj: LoginAuthWithCredentialsReturnObj = {
            loginAuthWithCredentials: this.loginAuthWithCredentials,
            userNamePass: true
          };
          return returnObj;
        } else if (this.utils.isAuthErrorResponse(this.loginOAuth)) {
          const errorId = this.utils.populatePingErrorResponse(this.loginOAuth);
          return {
            ...this.loginOAuth,
            errorId: errorId
          };
        }

        if (
          this.loginOAuth &&
          this.loginOAuth?.status === authConfig.COMPLETED
        ) {
          const swapAuthForAccessTokensParams: SwapAuthForAccessTokensParams = {
            authorizationCode: this.loginOAuth?.authorizeResponse?.code || '',
            oauthConfig: authConfig,
            pkcCodeGenerated: pkceCodeValue
          };
          this.swapAuthForAccessTokens = this.swapAuthForAccessTokens
            .access_token
            ? this.swapAuthForAccessTokens
            : await this.swapAuthForAccessTokenService.swapAuthForAccessTokens(
                swapAuthForAccessTokensParams
              );
          if (
            this.swapAuthForAccessTokens &&
            this.swapAuthForAccessTokens?.access_token
          ) {
            this.setLoggedInCookie(authConfig);
            return this.swapAuthForAccessTokens;
          } else if (
            this.utils.isAuthErrorResponse(this.swapAuthForAccessTokens)
          ) {
            const errorId = this.utils.populatePingErrorResponse(
              this.swapAuthForAccessTokens
            );
            return {
              ...this.swapAuthForAccessTokens,
              errorId: errorId
            };
          }
        }

        if (
          this.loginOAuth &&
          this.loginOAuth?.status === authConfig.IS_USER_REMEMBERED
        ) {
          this.loginAuthWithCredentials =
            await this.postWithFingerprintService.postWithFingerPrint(
              authConfig,
              this.loginOAuth.id || ''
            );
        } else if (this.utils.isAuthErrorResponse(this.loginOAuth)) {
          const errorId = this.utils.populatePingErrorResponse(this.loginOAuth);
          return {
            ...this.loginOAuth,
            errorId: errorId,
            accountLocked: this.utils.checkForAccessDenied(this.loginOAuth)
          };
        }

        if (
          this.loginAuthWithCredentials &&
          this.loginAuthWithCredentials?.status ===
            authConfig.USERNAME_PASSWORD_REQUIRED
        ) {
          const returnObj: LoginAuthWithCredentialsReturnObj = {
            loginAuthWithCredentials: this.loginAuthWithCredentials,
            userNamePass: true
          };
          return returnObj;
        } else if (
          this.utils.isAuthErrorResponse(this.loginAuthWithCredentials)
        ) {
          const errorId = this.utils.populatePingErrorResponse(
            this.loginAuthWithCredentials
          );
          return {
            ...this.loginAuthWithCredentials,
            errorId: errorId,
            accountLocked: this.utils.checkForAccessDenied(
              this.loginAuthWithCredentials
            )
          };
        }

        const {
          USERNAME_PASSWORD_REQUIRED,
          SHOULD_REMEMBER_USER,
          REMEMBERED_DEVICE_DETAILS,
          COMPLETED,
          RESUME
        } = authConfig;

        switch (this.loginAuthWithCredentials.status) {
          case USERNAME_PASSWORD_REQUIRED:
            if (
              this.loginAuthWithCredentials &&
              this.loginAuthWithCredentials?.status ===
                authConfig.USERNAME_PASSWORD_REQUIRED
            ) {
              this.loginAuthWithCredentials =
                await this.postWithCredService.postWithCredentials(
                  authConfig,
                  this.loginOAuth.id,
                  requestInput
                );
              if (
                this.utils.isAuthErrorResponse(this.loginAuthWithCredentials)
              ) {
                const errorId = this.utils.populatePingErrorResponse(
                  this.loginAuthWithCredentials
                );
                return {
                  ...this.loginAuthWithCredentials,
                  errorId: errorId,
                  accountLocked: this.utils.checkForAccessDenied(
                    this.loginAuthWithCredentials
                  )
                };
              }
            }
          /* falls through */
          case SHOULD_REMEMBER_USER:
            if (
              this.loginAuthWithCredentials &&
              this.loginAuthWithCredentials?.status ===
                authConfig.SHOULD_REMEMBER_USER
            ) {
              this.loginAuthWithCredentials =
                await this.postWithRememberUserService.postWithRememberUser(
                  authConfig,
                  this.loginOAuth.id,
                  requestInput
                );
              if (
                this.utils.isAuthErrorResponse(this.loginAuthWithCredentials)
              ) {
                const errorId = this.utils.populatePingErrorResponse(
                  this.loginAuthWithCredentials
                );
                return {
                  ...this.loginAuthWithCredentials,
                  errorId: errorId
                };
              }
            }
          /* falls through */
          case REMEMBERED_DEVICE_DETAILS:
            if (
              this.loginAuthWithCredentials?.status ===
              authConfig.REMEMBERED_DEVICE_DETAILS
            ) {
              this.loginAuthWithCredentials =
                await this.postWithContinue.postWithContinue(
                  authConfig,
                  this.loginOAuth.id || ''
                );
              if (
                this.utils.isAuthErrorResponse(this.loginAuthWithCredentials)
              ) {
                const errorId = this.utils.populatePingErrorResponse(
                  this.loginAuthWithCredentials
                );
                return {
                  ...this.loginAuthWithCredentials,
                  errorId: errorId
                };
              }
            }
          /* falls through */
          case COMPLETED:
            if (
              this.loginAuthWithCredentials?.status === authConfig.COMPLETED
            ) {
              const swapAuthForAccessTokensParams: SwapAuthForAccessTokensParams =
                {
                  authorizationCode:
                    this.loginAuthWithCredentials?.authorizeResponse?.code ||
                    '',
                  oauthConfig: authConfig,
                  pkcCodeGenerated: pkceCodeValue
                };
              this.swapAuthForAccessTokens =
                await this.swapAuthForAccessTokenService.swapAuthForAccessTokens(
                  swapAuthForAccessTokensParams
                );
              if (
                this.swapAuthForAccessTokens &&
                this.swapAuthForAccessTokens?.access_token
              ) {
                return this.swapAuthForAccessTokens;
              } else if (
                this.utils.isAuthErrorResponse(this.swapAuthForAccessTokens)
              ) {
                const errorId = this.utils.populatePingErrorResponse(
                  this.swapAuthForAccessTokens
                );
                return {
                  ...this.swapAuthForAccessTokens,
                  errorId: errorId
                };
              }
            }
          /* falls through */
          case RESUME:
            return this.loginAuthWithCredentials;
          default:
            break;
        }
      } else {
        if (this.swapAuthForAccessTokens.access_token) {
          return this.swapAuthForAccessTokens;
        } else if (
          !this.promptLoginFlow &&
          this.utils.isAuthErrorResponse(this.loginAuthWithCredentials)
        ) {
          this.loginAuthWithCredentials.status =
            authConfig.USERNAME_PASSWORD_REQUIRED;
        } else if (this.promptLoginFlow) {
          this.loginAuthWithCredentials =
            await this.postWithCredService.postWithCredentials(
              authConfig,
              this.loginOAuth.id || this.storedFlowId,
              requestInput
            );
          if (this.utils.isAuthErrorResponse(this.loginAuthWithCredentials)) {
            const errorId = this.utils.populatePingErrorResponse(
              this.loginAuthWithCredentials
            );
            if (
              errorId === 'ERROR_MSG_RESOURCE_NOT_FOUND' ||
              errorId === 'ERROR_MSG_1A8B' ||
              errorId === 'ERROR_MSG_SEC_CP_CHALLENGE'
            ) {
              this.loginOAuth.id = null;
              this.storedFlowId = null;
              return {
                errorId: errorId
              };
            } else {
              return {
                ...this.loginAuthWithCredentials,
                errorId: errorId,
                accountLocked: this.utils.checkForAccessDenied(
                  this.loginAuthWithCredentials
                )
              };
            }
          } else if (
            this.loginAuthWithCredentials &&
            this.loginAuthWithCredentials?.status === authConfig.COMPLETED
          ) {
            const swapAuthForAccessTokensParams: SwapAuthForAccessTokensParams =
              {
                authorizationCode:
                  this.loginAuthWithCredentials?.authorizeResponse?.code || '',
                oauthConfig: authConfig,
                pkcCodeGenerated: pkceCodeValue
              };
            this.swapAuthForAccessTokens =
              await this.swapAuthForAccessTokenService.swapAuthForAccessTokens(
                swapAuthForAccessTokensParams
              );
            if (this.utils.isAuthErrorResponse(this.swapAuthForAccessTokens)) {
              const errorId = this.utils.populatePingErrorResponse(
                this.swapAuthForAccessTokens
              );
              this.errorFromTokenCall = true;
              return {
                ...this.swapAuthForAccessTokens,
                errorId: errorId
              };
            } else {
              this.errorFromTokenCall = false;
              return Object.assign(
                this.swapAuthForAccessTokens,
                this.rememberMeDetails
              );
            }
          }
        }

        if (
          !(this.loginOAuth.id || this.storedFlowId) ||
          this.errorFromTokenCall
        ) {
          if (this.forcePromptLoginFlow) {
            loginOAuthParams.prompt = true;
          }
          this.loginOAuth = await this.authService.loginOAuth(
            loginOAuthParams,
            this.forcePromptLoginFlow ? true : false
          );
          this.storedFlowId = this.loginOAuth?.id;
          if (this.loginOAuth?.status === authConfig.COMPLETED) {
            this.loginAuthWithCredentials = this.loginOAuth;
          } else if (
            this.forcePromptLoginFlow &&
            this.loginOAuth?.status === authConfig.USERNAME_PASSWORD_REQUIRED
          ) {
            this.loginAuthWithCredentials =
              await this.postWithCredService.postWithCredentials(
                authConfig,
                this.loginOAuth.id || this.storedFlowId,
                requestInput
              );
            if (this.utils.isAuthErrorResponse(this.loginAuthWithCredentials)) {
              const errorId = this.utils.populatePingErrorResponse(
                this.loginAuthWithCredentials
              );
              if (
                errorId === 'ERROR_MSG_RESOURCE_NOT_FOUND' ||
                errorId === 'ERROR_MSG_1A8B' ||
                errorId === 'ERROR_MSG_SEC_CP_CHALLENGE'
              ) {
                this.loginOAuth.id = null;
                this.storedFlowId = null;
                return {
                  errorId: errorId
                };
              } else {
                return {
                  ...this.loginAuthWithCredentials,
                  errorId: errorId,
                  accountLocked: this.utils.checkForAccessDenied(
                    this.loginAuthWithCredentials
                  )
                };
              }
            }
          } else if (
            this.loginOAuth?.status !== authConfig.COMPLETED &&
            this.loginOAuth?.id
          ) {
            this.loginAuthWithCredentials =
              await this.postWithFingerprintService.postWithFingerPrint(
                authConfig,
                this.loginOAuth.id || ''
              );
          } else if (this.utils.isAuthErrorResponse(this.loginOAuth)) {
            const errorId = this.utils.populatePingErrorResponse(
              this.loginOAuth
            );
            return {
              ...this.loginOAuth,
              errorId: errorId
            };
          }
        }

        const {
          USERNAME_PASSWORD_REQUIRED,
          SHOULD_REMEMBER_USER,
          REMEMBERED_DEVICE_DETAILS,
          COMPLETED,
          RESUME
        } = authConfig;
        switch (this.loginAuthWithCredentials.status) {
          case USERNAME_PASSWORD_REQUIRED:
            if (
              this.loginAuthWithCredentials &&
              this.loginAuthWithCredentials?.status ===
                authConfig.USERNAME_PASSWORD_REQUIRED
            ) {
              this.loginAuthWithCredentials =
                await this.postWithCredService.postWithCredentials(
                  authConfig,
                  this.loginOAuth.id || this.storedFlowId,
                  requestInput
                );
              if (
                this.utils.isAuthErrorResponse(this.loginAuthWithCredentials)
              ) {
                const errorId = this.utils.populatePingErrorResponse(
                  this.loginAuthWithCredentials
                );
                if (
                  errorId === 'ERROR_MSG_RESOURCE_NOT_FOUND' ||
                  errorId === 'ERROR_MSG_1A8B' ||
                  errorId === 'ERROR_MSG_SEC_CP_CHALLENGE'
                ) {
                  this.loginOAuth.id = null;
                  this.storedFlowId = null;
                  return {
                    errorId: errorId
                  };
                } else {
                  return {
                    ...this.loginAuthWithCredentials,
                    errorId: errorId,
                    accountLocked: this.utils.checkForAccessDenied(
                      this.loginAuthWithCredentials
                    )
                  };
                }
              }
            }
          /* falls through */
          case SHOULD_REMEMBER_USER:
            if (
              this.loginAuthWithCredentials &&
              this.loginAuthWithCredentials?.status ===
                authConfig.SHOULD_REMEMBER_USER
            ) {
              this.loginAuthWithCredentials =
                await this.postWithRememberUserService.postWithRememberUser(
                  authConfig,
                  this.loginOAuth.id || '',
                  requestInput
                );
              if (
                this.utils.isAuthErrorResponse(this.loginAuthWithCredentials)
              ) {
                const errorId = this.utils.populatePingErrorResponse(
                  this.loginAuthWithCredentials
                );
                return {
                  ...this.loginAuthWithCredentials,
                  errorId: errorId
                };
              }
            }
          /* falls through */
          case REMEMBERED_DEVICE_DETAILS:
            if (
              this.loginAuthWithCredentials?.status ===
              authConfig.REMEMBERED_DEVICE_DETAILS
            ) {
              this.rememberMeDetails = {
                encyToken: this.loginAuthWithCredentials?.encryptedToken,
                uid: this.loginAuthWithCredentials?.fingerprint
              };
              this.loginAuthWithCredentials =
                await this.postWithContinue.postWithContinue(
                  authConfig,
                  this.loginOAuth.id || ''
                );
              if (
                this.utils.isAuthErrorResponse(this.loginAuthWithCredentials)
              ) {
                const errorId = this.utils.populatePingErrorResponse(
                  this.loginAuthWithCredentials
                );
                return {
                  ...this.loginAuthWithCredentials,
                  errorId: errorId
                };
              }
            }
          /* falls through */
          case COMPLETED:
            if (
              this.loginAuthWithCredentials?.status === authConfig.COMPLETED
            ) {
              const swapAuthForAccessTokensParams: SwapAuthForAccessTokensParams =
                {
                  authorizationCode:
                    this.loginAuthWithCredentials?.authorizeResponse?.code ||
                    '',
                  oauthConfig: authConfig,
                  pkcCodeGenerated: pkceCodeValue
                };
              this.swapAuthForAccessTokens = this.swapAuthForAccessTokens
                .access_token
                ? this.swapAuthForAccessTokens
                : await this.swapAuthForAccessTokenService.swapAuthForAccessTokens(
                    swapAuthForAccessTokensParams
                  );
              if (
                this.swapAuthForAccessTokens &&
                this.swapAuthForAccessTokens?.access_token
              ) {
                this.setLoggedInCookie(authConfig);
                this.errorFromTokenCall = false;
                return Object.assign(
                  this.swapAuthForAccessTokens,
                  this.rememberMeDetails
                );
              } else if (
                this.utils.isAuthErrorResponse(this.swapAuthForAccessTokens)
              ) {
                const errorId = this.utils.populatePingErrorResponse(
                  this.swapAuthForAccessTokens
                );
                this.errorFromTokenCall = true;
                return {
                  ...this.swapAuthForAccessTokens,
                  errorId: errorId
                };
              }
            }
          /* falls through */
          case RESUME:
            return this.loginAuthWithCredentials;
          default:
            break;
        }
      }
    } else {
      if (this.utils.isAuthErrorResponse(this.loginAuthWithCredentials)) {
        this.loginAuthWithCredentials.status =
          authConfig.USERNAME_PASSWORD_REQUIRED;
      }

      if (
        this.loginAuthWithCredentials &&
        this.loginAuthWithCredentials?.status ===
          authConfig.USERNAME_PASSWORD_REQUIRED
      ) {
        this.storedFlowId = redirectfulFlowId;
        this.loginAuthWithCredentials =
          await this.postWithCredService.postWithCredentials(
            authConfig,
            this.storedFlowId,
            requestInput
          );

        if (this.loginAuthWithCredentials.resumeUrl) {
          return this.loginAuthWithCredentials;
        }
        if (this.utils.isAuthErrorResponse(this.loginAuthWithCredentials)) {
          const errorId = this.utils.populatePingErrorResponse(
            this.loginAuthWithCredentials
          );
          if (
            errorId === 'ERROR_MSG_RESOURCE_NOT_FOUND' ||
            errorId === 'ERROR_MSG_1A8B' ||
            errorId === 'ERROR_MSG_SEC_CP_CHALLENGE'
          ) {
            this.storedFlowId = null;
            return {
              errorId: errorId
            };
          } else {
            return {
              ...this.loginAuthWithCredentials,
              errorId: errorId,
              accountLocked: this.utils.checkForAccessDenied(
                this.loginAuthWithCredentials
              )
            };
          }
        }
      }
    }
  }

  removeLoggedInSessionStorage(authConfig: OauthAEMConfig) {
    if (authConfig?.WIFI_SESSION_STORAGE) {
      let loggedIn = JSON.parse(sessionStorage.getItem('loggedIn'));
      if (loggedIn && new Date().getTime() - loggedIn.time > 1799000) {
        sessionStorage.removeItem('loggedIn');
        loggedIn = null;
      }
    }
  }

  setLoggedInCookie(authConfig: OauthAEMConfig) {
    if (
      !sessionStorage.getItem('loggedIn') &&
      authConfig?.WIFI_SESSION_STORAGE
    ) {
      const currentTime = new Date().getTime();
      sessionStorage.setItem(
        'loggedIn',
        JSON.stringify({
          time: currentTime,
          loggedIn: true
        })
      );
    }
  }
}
